import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, model, signal, untracked, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { DecimalPlacesCustomPipe } from '../../../../@core/pipes';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { Document, DocumentLineItem } from '../../../../generated/generated-types';
import { ProductStockChartDiagramComponent } from '../../../warehouse/modules/product-stock-chart-diagram/product-stock-chart-diagram.component';
import { LineItemDataService } from '../../services/line-item-data.service';

export interface StockDataInput {
  name: string;
  storagePlaceId: string;
  reserved: number;
  ordered: number;
  openSales: number;
  totalStock: number;
  reservedDocument?: boolean;
  quarantineStock: number;
}

@Component({
  selector: 'app-storage-quantity-info-dli-statusbar',
  imports: [CommonModule, SkeletonModule, TreeTableModule, ButtonModule, TranslatePipe, TooltipModule, DecimalPlacesCustomPipe, DrawerModule, ProductStockChartDiagramComponent],
  templateUrl: './storage-quantity-info-dli-statusbar.component.html',
  styleUrl: './storage-quantity-info-dli-statusbar.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StorageQuantityInfoDliStatusbarComponent {

  dli = input<DocumentLineItem>();
  doc = input<Document>();
  stockDataArrayInput = input<StockDataInput[]>();
  liveChangesCurrentWarehouse = model<Partial<StockDataInput>>();

  stockData = signal<StockDataInput[]>([]);
  productStorageVisible = signal(false);

  constructor(
    private lineItemStatusService: LineItemDataService,
    private i18n: I18nService,
  ) {
    effect(() => {
      let stockDataInput = this.stockDataArrayInput();
      untracked(() => {
        this.stockData.set(stockDataInput);
      });
    });
    effect(() => {
      let liveChanges = this.liveChangesCurrentWarehouse();
      untracked(() => {
        let changedStockData = [];
        for (const entry of this.stockData()) {
          let changedEntry: StockDataInput;
          if ((liveChanges?.storagePlaceId === entry.storagePlaceId) || entry.storagePlaceId === '') {
            changedEntry = {
              name: entry.name,
              storagePlaceId: entry.storagePlaceId,
              reserved: entry.reserved + (this.liveChangesCurrentWarehouse()?.reserved ?? 0),
              ordered: entry.ordered + (this.liveChangesCurrentWarehouse()?.ordered ?? 0),
              openSales: entry.openSales + (this.liveChangesCurrentWarehouse()?.openSales ?? 0),
              totalStock: entry.totalStock + (this.liveChangesCurrentWarehouse()?.totalStock ?? 0),
              quarantineStock: entry.quarantineStock + (this.liveChangesCurrentWarehouse()?.quarantineStock ?? 0)
            };
          } else {
            changedEntry = entry;
          }
          changedStockData.push(changedEntry);
        }
        this.stockData.set(changedStockData);
      });
    })
  }

}
